if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

connectedCallback() {
  this.selectors = {
    sliderWrapper: '.collection-list__items',
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  };

  this.classes = {
    grid: 'f-grid',
    swiper: 'swiper',
    swiperWrapper: 'swiper-wrapper',
  };

  this.sectionId = this.dataset.sectionId;
  this.section = this.closest(`.section-${this.sectionId}`);
  this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  this.cardStyle = this.dataset.cardStyle;
  this.itemSize = this.dataset.itemSize;
  this.columnsDesktop = this.dataset.columnsDesktop;

  this.sliderInstance = false;

  // use a persistent mql so we can re-init on breakpoint change
  this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
  if (this.mql.addEventListener) {
    this.mql.addEventListener('change', this.init.bind(this));
  } else {
    this.mql.addListener(this.init.bind(this));
  }

  this.init();
}

  

    init() {
  // If there is an existing instance, destroy it first so breakpoints/options reapply cleanly
  if (this.sliderInstance && typeof this.sliderInstance === 'object') {
    this.destroySlider();
  }

  // Always create/init the slider (mobile and desktop)
  this.initSlider();
}


    initSlider() {
 const sliderOptions = {
  modules: [
    FoxTheme.Swiper.Navigation,
    FoxTheme.Swiper.Pagination,
    FoxTheme.Swiper.Mousewheel,
    FoxTheme.Swiper.Autoplay,
  ],
  slidesPerView: 2,  // ✅ auto for mobile too
  spaceBetween: 12,
  allowTouchMove: true,
  simulateTouch: true,
  navigation: {
    nextEl: this.section.querySelector(this.selectors.nextEl),
    prevEl: this.section.querySelector(this.selectors.prevEl),
  },
  pagination: false,
  loop: true,
  threshold: 2,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  breakpoints: {
    768: {
      spaceBetween: this.cardStyle == 'card' ? 8 : 20,
      slidesPerView:
        this.itemSize == 'fixed'
          ? (this.columnsDesktop > 4 ? 4 : this.columnsDesktop)
          : 'auto',
    },
    1024: {
      spaceBetween: this.cardStyle == 'card' ? 8 : 20,
      slidesPerView:
        this.itemSize == 'fixed'
          ? (this.columnsDesktop > 6 ? this.columnsDesktop - 1 : this.columnsDesktop)
          : 'auto',
    },
    1280: {
      spaceBetween: this.cardStyle == 'card' ? 8 : 20,
      slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
    },
  },
};


  // create slider if not already an object
  if (typeof this.sliderInstance !== 'object') {
    this.classList.add(this.classes.swiper);
    this.sliderWrapper.classList.remove(this.classes.grid);
    this.sliderWrapper.classList.add(this.classes.swiperWrapper);

    this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
    this.sliderInstance.init();

    const focusableElements = FoxTheme.a11y.getFocusableElements(this);

    focusableElements.forEach((element) => {
      element.addEventListener('focusin', () => {
        const slide = element.closest('.swiper-slide');
        this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
      });
    });

    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        if (e.detail.sectionId != this.sectionId) return;
        let { target } = e;
        const index = Number(target.dataset.index);

        this.sliderInstance.slider.slideTo(index);
      });
    }
  }
}


    

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
